import { render, staticRenderFns } from "./answershortquestion.vue?vue&type=template&id=3c48b5be&scoped=true&"
import script from "./answershortquestion.vue?vue&type=script&lang=js&"
export * from "./answershortquestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c48b5be",
  null
  
)

export default component.exports